import React from "react";
import { MainWrapper, TopContainer, MainHeader, ButtonContainer, Button, Header2, Info, Bullet } from "./styles";
import Spinner from "../../components/Spinner/Spinner";
import { ImageMosaic } from "../../components/ImageMosaic";
import { getResourceById } from "../../services/resources/getResources";
import { ROUTES } from '../../routes/constants';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getPlaceById } from "../../services/places/getPlaces";
import { Divider } from "@mui/material";

const ResourceDetails = () => {
    // ------------------- JWT -------------------
    const jwt = localStorage.getItem('jwt');
    const userType = localStorage.getItem('user_type');

    const { id } = useParams();
    const resourceId = id || "No ID available";
    const navigate = useNavigate();

    // ------------------- REMOVE THIS -------------------
    const images = [
        "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg",
        "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg",
        "https://images.unsplash.com/photo-1554260570-e9689a3418b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2364&q=80",
        "https://images.unsplash.com/photo-1614028674026-a65e31bfd27c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80",
        "https://images.unsplash.com/photo-1564038057903-1d48b852b412?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80",
    ];

    // ------------------- STATES -------------------
    const [loadingResource, setLoadingResource] = React.useState(false);
    const [loadingPlace, setLoadingPlace] = React.useState(false);
    const [resource, setResource] = React.useState<any>({});
    const [place, setPlace] = React.useState<any>(null);

    // ------------------- USE EFFECT -------------------
    React.useEffect(() => {
        setLoadingResource(true);
        getResource();
    }, []);

    React.useEffect(() => {
        setLoadingPlace(true);
        getPlace();
    }, [resource]);

    // ------------------- GET RESOURCES FROM API -------------------
    const getResource = async () => {
        await getResourceById(parseInt(resourceId), jwt!)
            .then((res) => {
                if (res && res.data) {
                    setResource(res.data);
                }
            })
            .catch((err) => {
                console.log(err, "err");
            });

        // setTimeout(() => {
        //     setLoadingResource(false);
        // }, 3000);
        setLoadingResource(false);
    };

    const getPlace = async () => {
        await getPlaceById(parseInt(resource.resource?.location), jwt!)
            .then((res) => {
                if (res && res.data) {
                    setPlace(res.data);
                }
            })
            .catch((err) => {
                console.log(err, "err");
            });

        // setTimeout(() => {
        //     setLoadingPlace(false);
        // }, 3000);
        setLoadingPlace(false);
    }

    return (
        <>
            {!loadingResource && !loadingPlace ? (
                <MainWrapper>
                    <TopContainer>
                        <MainHeader>{resource.resource?.name}</MainHeader>
                        <ImageMosaic
                            width="100%"
                            images={
                                // resource.resource.images?.map((img: any) => img.url)
                                images.map((img: any) => img)
                            }
                        />
                    </TopContainer>
                    <div>
                        <Header2>Tipo de recurso</Header2>
                        <Divider sx={{ margin: "20px auto" }} />
                        <Info>{resource.resource?.resource_type}</Info>

                        <Header2>Ubicación</Header2>
                        <Divider sx={{ margin: "20px auto" }} />
                        <ul>
                            <Bullet>Edificio - {place?.building}</Bullet>
                            <Bullet>Piso - {place?.floor}</Bullet>
                            <Bullet>Sala - {place?.room}</Bullet>
                        </ul>

                        <Header2>Descripción</Header2>
                        <Divider sx={{ margin: "20px auto" }} />
                        <Info>{resource.resource?.description}</Info>

                        <ButtonContainer>
                            <Button color="blue">Editar</Button>
                            <Button color="red">Eliminar</Button>
                        </ButtonContainer>
                    </div>
                </MainWrapper>
            ) : (
                <Spinner />
            )}
        </>
    );
};

export default ResourceDetails;
